let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("koIFB")).then(() => parcelRequire('2LXP4'));